import { render, staticRenderFns } from "./KResponsive.vue?vue&type=template&id=a521b9f4&scoped=true&"
import script from "./KResponsive.vue?vue&type=script&lang=js&"
export * from "./KResponsive.vue?vue&type=script&lang=js&"
import style0 from "./KResponsive.vue?vue&type=style&index=0&id=a521b9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a521b9f4",
  null
  
)

export default component.exports